import { connect } from 'react-redux';
import SquarePlates from './SquarePlates';
import Panel from '@scene/objects/panel';

import { setPanelType } from '@reducers/options/panel/actions';
import { setSquareScrews } from '@reducers/options/screw/actions';
import { setMode } from '@reducers/actions';
import ObjectView from '@scene/views/object-view';
import { setEditorVerticesType, setEditorAnchorsType } from '@reducers/selectors/editor/actions';
import { VERTICES } from '@components/Editor/types';
import { setCustomCoordinates } from '@reducers/selectors/dimension/actions';

const mapState = state => ({
  designStandard: +state.main.localization.designStandard,
  appType: state.main.appType,

  count: state.options.screw.count,
  panelType: state.options.panel.type,
  specifyCoordinates: (state.selectors.dimension[state.main.appType].basePlate && 
    state.selectors.dimension[state.main.appType].basePlate.spacing && 
    state.selectors.dimension[state.main.appType].basePlate.spacing.specifyCoordinates) || false
});

const mapDispatch = dispatch => ({
  setSquare: (n = 1, m = 1, ignorePositions, isCustom, isUpdatePadding) => {
    dispatch(setPanelType(Panel.types.SQUARE));
    dispatch(setSquareScrews(n, m, ignorePositions, isCustom, isUpdatePadding));
  },

  setCustomSquare: (obj = {}) => {
    dispatch(setPanelType(Panel.types.SQUARE));
    dispatch(setSquareScrews(obj.n > 25 ? 25 : obj.n, obj.m > 25 ? 25 : obj.m, null, true));
  },

  on2DEditor: (panelType, activeBtn) => {
    dispatch(setMode(ObjectView.mode.MODE_2D_EDITOR));
    
    switch (panelType) {
      case Panel.types.CIRCLE: {
        dispatch(setEditorVerticesType(VERTICES.CIRCLE));
        break;
      }
      case Panel.types.TRIANGLE: {
        dispatch(setEditorVerticesType(VERTICES.TRIANGLE));
        break;
      }
      case Panel.types.CUSTOM :{
        break;
      }
      default: {
        dispatch(setEditorVerticesType(VERTICES.SQUARE));
        break;
      }
    }

    if (activeBtn !== "2DEditor")
      dispatch(setEditorAnchorsType()); // clear type
      
  },
  setCustomCoordinates: (value) => dispatch(setCustomCoordinates(value))
});

export default connect(
  mapState,
  mapDispatch
)(SquarePlates);



// WEBPACK FOOTER //
// ./src/views/Application/SquarePlates/index.js